import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { IAddress } from './address'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IPayer extends IModelBase {
  Name: string
  MailingAddressId: number
  MailingAddress: IAddress
  PhysicalAddressId: number
  PhysicalAddress: IAddress
  ModifiedByFullName: string
  ModifiedOn: Date
}

@Injectable()
export class PayerODataService extends ODataService<IPayer> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'Payers'
  }
}
